import React, { useEffect, useReducer, useState } from "react"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import partsReducer, {
  getActions,
} from "@/components/PartsViewer/v2/partReducer.js"
import DesktopView from "@/components/PartsViewer/v2/SelectedFileView/DesktopView"
import MobileView from "@/components/PartsViewer/v2/SelectedFileView/MobileView"

const SelectedFileView = props => {
  const {
    selectedFile,
    expandHandler,
    partsList,
    setIsListExtend,
    isListExtend,
    title,
    showPopup,
    popupModal,
    setModal,
    productId,
    selected,
    tabsActive,
    panelState,
    onClose,
    sku,
    prefeedbackController,
    loading,
    analytics,
    showCart,
    setShowCart,
    showCartPopUp,
    siteName,
  } = props || {}
  const [partsState, dispatch] = useReducer(partsReducer, { parts: [] })
  const [widthSize, setWidthSize] = useState(0)
  const [cartToast, setCartToast] = useState(null)
  const partsActions = getActions(partsState, dispatch)
  const { t } = useTranslation("common")
  const { cartNotificationText } = getTranslations(t)

  useEffect(() => partController.actions.initPartsList(selected), [selected])

  let isDesktop
  const screenWidth = window.innerWidth
  if (screenWidth > 812) {
    isDesktop = true
  }
  const partController = {
    state: partsState,
    actions: partsActions,
  }

  useEffect(() => {
    let timeOut
    if (cartToast?.status) {
      timeOut = setTimeout(() => {
        setCartToast(null)
      }, 2000)
    }
    return () => {
      clearTimeout(timeOut)
    }
  })
  const value = cartToast?.quantity > 1 ? "Items" : "Item"
  return (
    <>
      {!isDesktop ? (
        <MobileView
          expandHandler={expandHandler}
          panelState={panelState}
          showPopup={showPopup}
          selectedFile={selectedFile}
          partsList={partsList}
          setIsListExtend={setIsListExtend}
          isListExtend={isListExtend}
          title={title}
          productId={productId}
          tabsActive={tabsActive}
          setModal={setModal}
          popupModal={popupModal}
          selected={selected}
          onClose={onClose}
          sku={sku}
          partController={partController}
          prefeedbackController={prefeedbackController}
          loading={loading}
          analytics={analytics}
          setWidthSize={setWidthSize}
          showCart={showCart}
          setShowCart={setShowCart}
          showCartPopUp={showCartPopUp}
          setCartToast={setCartToast}
          siteName={siteName}
        />
      ) : (
        <>
          <DesktopView
            expandHandler={expandHandler}
            fullscreen={panelState}
            showPopup={showPopup}
            selectedFile={selectedFile}
            partsList={partsList}
            setIsListExtend={setIsListExtend}
            isListExtend={isListExtend}
            title={title}
            productId={productId}
            setModal={setModal}
            popupModal={popupModal}
            selected={selected}
            partController={partController}
            sku={sku}
            loading={loading}
            analytics={analytics}
            setWidthSize={setWidthSize}
            widthSize={widthSize}
            showCart={showCart}
            setShowCart={setShowCart}
            showCartPopUp={showCartPopUp}
            setCartToast={setCartToast}
            siteName={siteName}
          />
        </>
      )}

      {cartToast?.status ? (
        <div className="cart-toast-message cart-toast-text">
          <p>{cartNotificationText(cartToast?.quantity, value)}</p>
        </div>
      ) : (
        ""
      )}
    </>
  )
}

export default SelectedFileView
